import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
// import { RpmConstants } from '../constants';
import { IS_SKIP_HANDLE_ERROR } from './api/api-http-context-token';
import { AuthService } from './api/auth.service';
import { IAppConfig } from './config/app-config.model';
import { APP_CONFIG } from './config/app-config.service';
import { ErrorService } from './error.service';
import { LogService } from './log.service';
import { PlatformService } from './platform.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  errors: any[] = [];
  constructor(
    @Inject(APP_CONFIG) protected config: IAppConfig,
    private platform: PlatformService,
    private errorService: ErrorService, 
    private router: Router,
    private auth: AuthService,
    private messageService: MessageService,
    private translate: TranslateService,
    private log: LogService,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isAuthenticated = this.auth.isLoggedIn();

        return next.handle(request).pipe(
          tap(res => {
            if(res.type === 4 && res.status === 200){
              const body: any = res.body;
              if(body){
                if(!body.success && body.errors && body.errors.length){
                  const errorCode = body.errors[0].code;
                  const desc = body.errors[0].description;

                  if(window.location.href.indexOf('localhost') !== -1 && errorCode === 'CRSAPIGateway'){
                    return;
                  }

                  if(request.context?.get(IS_SKIP_HANDLE_ERROR) === true){
                    return
                  }
                  
                  // If error code starts with BS or DS => show code + "common.error.general"
                  // DS0701: Reset password code is expired.
                  // if(/^(BS|DS)/i.test(errorCode) && errorCode !== 'DS0701'){
                  if(!desc){
                    this.translate.get('common.error.general').subscribe(value => {
                      this.messageService.add({severity:'error', summary: `Error ${errorCode}`, detail: value, key: 'toast'});
                    });
                    return;
                  }
                  
                  this.messageService.add({severity:'error', summary: `Error ${errorCode}`, detail: desc, key: 'toast'});

                  // Invalid token
                  if(errorCode === 'XWAPI202' && this.config.isUsingExternalIdentityServer){
                    // logout from keycloak
                    setTimeout(() => {
                      this.auth.forceLogout();
                    }, 3000);
                  }
                }
              }
            }
          }),
          tap({
            error: (err) => {
              if (window.navigator.onLine) {
                if(request.context?.get(IS_SKIP_HANDLE_ERROR) === true){
                  this.log.log(`ErrorInterceptor IS_SKIP_HANDLE_ERROR: ${JSON.stringify(err)}`);
                  if(err){
                    (err as any).handled = true;
                  }
                  return throwError(() => err);
                }
  
                this.log.log(`ErrorInterceptor catchError: ${JSON.stringify(err)}`);
                if ([401, 403, 409].includes(err.status) /*&& isAuthenticated*/) {
                  // auto logout if 401 or 403 response returned from api
                  if (!this.router.url.includes("login")) {
                    if(err.status === 409){
                      this.auth.show409Error();
                    }
                    if(err.status === 401){
                      // this.auth.show401Error();
                    }
                    setTimeout(() => {
                      this.auth.logout(true, undefined, err && err.status === 409 ? 2000: 0);
                      sessionStorage.clear();
                    }, err.status === 401 ? 1000 : 4000);
                    return throwError(() => err);
                  }
                }
  
                return throwError(() => err);
              } else {
                //Internet interrupt
                return throwError(() => "12004");
              }
            }
          })
        );
  }
}